module.exports = __webpack_public_path__ + "aaaa300f7a1d70a7011fdead7602a3c0.svg";